export default __webpack_public_path__ + "assets/ff84a0dda4f5b41dca374d915a1e9c84.woff";